/**
 * @prettier
 * @flow
 */
export const KEY_NAME = 'device';

export function getDeviceInLocaleStorage(): string {
    let item = window.localStorage.getItem('device');
    return JSON.parse(item) ?? '';
}
